import {DialogController} from "aurelia-dialog";
import {inject} from "aurelia-framework";
import EditorContent from "../utils/editor-content";

@inject(DialogController)
export class FormChoice
{
    constructor(dialogController, client)
    {
        this.dialogController = dialogController;
        this.client = client;
    }

    activate(context)
    {
        this.formId = context.formId;
        this.data = context.data;
        this.title = context.title;
        this.contextObj = EditorContent.reference;

        if (context.contextModelId) {
            if (!this.data) {
                this.data = {};
            }
            this.data.contextModelId = context.contextModelId;
        }
    }

    submit(object)
    {
        this.dialogController.ok(object);

        return Promise.resolve();
    }
}
